import React, { Component } from 'react';
import PropTypes from 'prop-types';
import CenterInitiatedRepatriationsTransactionsCreateDialog
  from './CenterInitiatedRepatriationsTransactionsCreateDialog';

class CenterInitiatedRepatriationsTransactionsCreate extends Component {
  render() {
    return (
      <div>
        <CenterInitiatedRepatriationsTransactionsCreateDialog
          row={this.props}
          closeDialog={this.props.closeDialog}
          openDialog={this.props.openDialog}
          refreshTransactions={this.props.refreshTransactions}
        />
      </div>
    );
  }
}

CenterInitiatedRepatriationsTransactionsCreate.propTypes = {
  closeDialog: PropTypes.func.isRequired,
  openDialog: PropTypes.func.isRequired,
  refreshTransactions: PropTypes.func,
};

export default CenterInitiatedRepatriationsTransactionsCreate;
